module.exports = __webpack_public_path__ + "static/img/20181213091506_445646.bef28048.jpg";